export default __webpack_public_path__ + "static/media/305.e47ae057.png";